import styled from 'styled-components';
import FinalPayment from '../../components/payment/finalPayment/FinalPayment';
import PaymentMethod from '../../components/payment/paymentMethod/PaymentMethod';

export const Main = styled.main`
    padding: 149px 16.66666666666667% 358px;
`;

export const H2 = styled.h2`
    font-weight: 700;
    font-size: 2.25rem;
    line-height: 2.75rem;
    text-align: center;
`;

export const PaymentInfo = styled.section``;

export const PaymentHeader = styled.div`
    padding: 1.40625% 8px 1.40625%;
    background-color: #f2f2f2;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 52px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.438rem;
`;

export const ProductInfo = styled.div`
    width: 46.04430379746835%;
`;

export const Div = styled.div`
    flex: 1 1 0;
`;

export const Total = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    margin-top: 30px;
`;

export const Span = styled.span`
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.438rem;
    margin-right: 0.78125%;
`;

export const TotalPrice = styled.strong`
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.875rem;
    color: #eb5757;
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
`;

export const StyledPaymentMethod = styled(PaymentMethod)`
    width: 59.375%;
`;

export const StyledFinalPayment = styled(FinalPayment)`
    width: 37.5%;
`;
